import produce from 'immer';

import { ReducerAction } from 'store/modules/types';

import { Types, PGAT } from './types';

export const INITIAL_STATE: PGAT = {
	status: 0,
	mensagem: '',
	data: {
		codigoRetorno: '',
		tipoCliente: 0,
		tipoPesquisa: {
			codigo: '',
			descricao: '',
		},
		chassi: '',
		placa: '',
		contrato: '',
		nomeAgente: '',
		cpfCnpjAgente: '',
		nomeFinanciado: '',
		cpfCnpjFinanciado: '',
		dataInclusao: '',
		tipoRestricao: {
			codigo: '',
			descricao: '',
		},
	},
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): PGAT {
	return produce(state, draft => {
		switch (action.type) {
			case Types.PGAT_REQUEST: {
				break;
			}

			case Types.PGAT_SUCCESS: {
				draft.status = action.payload.status;

				draft.data = action.payload.data;

				break;
			}

			case Types.PGAT_FAILURE: {
				const { status, data, message } = action.payload;

				draft.status = status || data.status;

				draft.data = data;

				draft.mensagem = `${data.data.codigo} - ${message}`;

				break;
			}

			case Types.PGAT_CLEAR: {
				draft.status = 0;

				draft.data = INITIAL_STATE.data;

				break;
			}

			default:
		}

		return draft;
	});
}
